import { type FC } from 'react';
import { IconAlertTriangle, IconRefresh } from '@tabler/icons-react';
import { Alert, Button, Group, Paper, Stack, Text } from '@mantine/core';
import { PayoutTraderStatus, type PayoutTrader, type PayoutTraderRate } from '~/entities/payout';
import { type UpdateTraderRateRequest } from '../../model';
import { TraderRateForm } from './components';

interface TraderRateCardProps {
    fallbackTraderId: string;
    isRateError: boolean;
    isRateLoading: boolean;
    isUpdateRatePending: boolean;
    onReloadRate: () => void;
    onUpdateRate: (values: UpdateTraderRateRequest) => void;
    rate?: PayoutTraderRate;
    rateFormKey?: string;
    trader?: PayoutTrader;
    traderId?: string;
}

export const TraderRateCard: FC<TraderRateCardProps> = ({
    fallbackTraderId,
    isRateError,
    isRateLoading,
    isUpdateRatePending,
    onReloadRate,
    onUpdateRate,
    rate,
    rateFormKey,
    trader,
    traderId,
}) => {
    if (!trader || trader.status === PayoutTraderStatus.STATUS_CREATED) {
        return null;
    }

    const effectiveTraderId = traderId ?? fallbackTraderId;

    return (
        <Paper
            p='md'
            radius='md'
            withBorder
        >
            <Stack gap='md'>
                <Text
                    fw={600}
                    size='sm'
                >
                    Комиссия
                </Text>

                {isRateError ? (
                    <Alert
                        color='red'
                        title='Не удалось загрузить комиссию'
                        icon={<IconAlertTriangle size={18} />}
                    >
                        <Stack gap='xs'>
                            <Text size='sm'>
                                Текущие значения не загрузились, поэтому сохранение временно недоступно.
                            </Text>

                            <Group justify='flex-end'>
                                <Button
                                    size='xs'
                                    variant='light'
                                    color='red'
                                    leftSection={<IconRefresh size={14} />}
                                    loading={isRateLoading}
                                    disabled={isRateLoading}
                                    onClick={onReloadRate}
                                >
                                    Повторить
                                </Button>
                            </Group>
                        </Stack>
                    </Alert>
                ) : (
                    <TraderRateForm
                        key={rateFormKey}
                        traderId={traderId}
                        fallbackTraderId={effectiveTraderId}
                        rate={rate}
                        isLoading={isUpdateRatePending}
                        isRateLoading={isRateLoading}
                        onSubmit={onUpdateRate}
                    />
                )}
            </Stack>
        </Paper>
    );
};
